import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { RoutesConfig } from 'navigation/routes';
import { AppMode } from 'store/Common/reducers/common';
import { getModelIdFromPath } from 'providers/QueryProvider/hooks';

// Shared by the Header, which expands its SubHeader, and DashboardLayout, which
// sizes the spacer below the fixed header - both have to agree or the page
// content ends up under the header.
export const useIsHeaderSubHeaderExpanded = (): boolean => {
  const location = useLocation();
  const appMode: AppMode = useSelector(
    (state: IRootReducerState) => state.commonInfo.appMode
  );
  const modelId = getModelIdFromPath();

  if (appMode === AppMode.EXTERNAL) {
    return true;
  }
  return (
    location.pathname.includes(RoutesConfig.Configure.fullPath) && !!modelId
  );
};
